import IndexPage from "./IndexPage"
import AboutUsPage from "./AboutUsPage"
import FaqPage from "./FaqPage"
import ContactsPage from "./ContactsPage"
import FeaturesPage from "./FeaturesPage"
import AffiliatesPage from "./AffiliatesPage"
import PartnersPage from "./PartnersPage"
import BlogPage from "./BlogPage"
import BlogPostPage from "./BlogPostPage"
import PaymentResultPage from "./PaymentResultPage"
import LandingPage from "./LandingPage"
import ProtectedAccountPage from "./AccountPage/ProtectedAccountPage"
import BuyPage from "./BuyPage"
import GridTestPage from "./GridTestPage"

// Register all site page routes at once using an object
export default {
  // Main pages
  "/": IndexPage,
  "/index": IndexPage,
  "/about-us": AboutUsPage,
  "/faq": FaqPage,
  "/features": FeaturesPage,
  "/contacts": ContactsPage,
  "/blog": BlogPage,

  // Partner/Affiliate pages
  "/affiliates": AffiliatesPage,
  "/become-a-partner": PartnersPage,

  // Platform pages - using same home component for now
  "/android": IndexPage,
  "/ios": IndexPage,
  "/windows": IndexPage,

  // Platform feature pages
  "/android/features": FeaturesPage,
  "/android/features/*": FeaturesPage,
  "/ios/features": FeaturesPage,
  "/ios/features/*": FeaturesPage,
  "/windows/features": FeaturesPage,
  "/windows/features/*": FeaturesPage,

  // Blog post route with dynamic postID parameter
  "/blog/*": BlogPostPage,

  // Account page routes
  "/account": ProtectedAccountPage,
  "/account/*": ProtectedAccountPage,

  // Placeholder for missing pages
  "/landing-page": LandingPage,
  // Purchase deep link for external landing pages (adds product, opens cart)
  "/buy": BuyPage,
  "/payment-result": PaymentResultPage,

  // Test pages
  "/grid": GridTestPage,
}

